import React from 'react'
import './Flow.css'

import { type PaperSizes } from 'components/atoms/Paper'

type FlowProps = {
  space: ArrayElement<typeof PaperSizes>
  children: React.ReactNode
}

const Flow = ({ space, children }: FlowProps): JSX.Element => (
  <div
    className="Flow"
    style={{
      // @ts-expect-error: the custom properties are valid properties for the style object
      '--flow-space': space && `${space}px`,
    }}
  >
    {children}
  </div>
)

export default Flow
